import React, { useCallback, useLayoutEffect, useRef } from "react";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { BackBarButtonMini } from "../../common/backBarButton";
import { MoviesSlider } from "./categoryList";
import smoothScroll from "../../../utils/animateScroll";
import { getVerticalFocusScrollTarget } from "../../../utils/focusScroll";
import { useInputMode } from "../../../utils/hooks/useInputMode";

// ============================================================================
// MAIN COMPONENT
// ============================================================================

var GridContent = function (props) {
  const { data, slug, title } = props;
  var { ref, focusKey } = useFocusable();
  var innerRef = useRef(null);
  var { isMouseFocus, isMouseFocusRef } = useInputMode();

  useLayoutEffect(function () {
    if (ref.current) {
      ref.current.scrollTop = 0;
      ref.current.scrollLeft = 0;
    }
  }, [ref, data]);

  var onRowFocus = useCallback(
    function (focusProps) {
      if (!ref.current || isMouseFocusRef.current) return;

      var targetScroll = getVerticalFocusScrollTarget(ref.current, focusProps || {}, {
        topPadding: 88,
        bottomPadding: 128,
        align: "center",
      });

      smoothScroll(ref, targetScroll, 500, isMouseFocus);
    },
    [ref, isMouseFocus, isMouseFocusRef]
  );

  return (
    <div className="legacy-profile-list-shell">
      <div className="legacy-profile-list-inner">
        <FocusContext.Provider value={focusKey}>
          <div className="legacy-profile-list-scroll" ref={ref}>
            <div>
              <div className="legacy-profile-list-header">
                <div className="legacy-profile-list-header-cell">
                  <BackBarButtonMini />
                  <h4 className="legacy-profile-list-title">{title}</h4>
                </div>
              </div>

              <div className="legacy-profile-list-content" ref={innerRef}>
                {data && data.length > 0 ? (
                  <MoviesSlider
                    movies={data}
                    onFocus={onRowFocus}
                    slug={slug}
                    isWatchHistory={props.isWatchHistory || title === "تاریخچه تماشا"}
                  />
                ) : (
                  <div className="legacy-profile-list-empty">
                    <p>محتوایی یافت نشد</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </FocusContext.Provider>
      </div>
    </div>
  );
};

export default GridContent;
